/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { WorkDTO } from './WorkDTO';
import {
    WorkDTOFromJSON,
    WorkDTOFromJSONTyped,
    WorkDTOToJSON,
    WorkDTOToJSONTyped,
} from './WorkDTO';

/**
 * 
 * @export
 * @interface PageResponseListWorkDTO
 */
export interface PageResponseListWorkDTO  {
    /**
     * 
     * @type {Array<WorkDTO>}
     * @memberof PageResponseListWorkDTO
     */
    content?: Array<WorkDTO>;
    /**
     * 
     * @type {string}
     * @memberof PageResponseListWorkDTO
     */
    nextPageCursor?: string;
}

/**
 * Check if a given object implements the PageResponseListWorkDTO interface.
 */
export function instanceOfPageResponseListWorkDTO(value: object): value is PageResponseListWorkDTO {
    return true;
}

export function PageResponseListWorkDTOFromJSON(json: any): PageResponseListWorkDTO {
    return PageResponseListWorkDTOFromJSONTyped(json, false);
}

export function PageResponseListWorkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageResponseListWorkDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(WorkDTOFromJSON)),
                  'nextPageCursor': json['nextPageCursor'] == null ? undefined : json['nextPageCursor'],
    };
}

export function PageResponseListWorkDTOToJSON(json: any): PageResponseListWorkDTO {
    return PageResponseListWorkDTOToJSONTyped(json, false);
}

export function PageResponseListWorkDTOToJSONTyped(value?: PageResponseListWorkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(WorkDTOToJSON),
        'nextPageCursor': value['nextPageCursor'],
    };
}


